export enum PlatformType {
  Unknown = 0,
  S1Intranet = 1,
  CustomerMobileAppIos = 2,
  CustomerMobileAppAndroid = 3,
}
